<template>
     <div class="record-documententry">
        <PageTitle icon="fa fa-exchange" main="Registro" sub="Entrada de Documento"/>
         <b-form>
               <b-row>
                    <input id="documententry-id" type="hidden" v-model="documententry.id" />
                    <b-col md="2" sm="12">
                            <b-form-group 
                            label="Tipo de Documento:" 
                            label-for="documententry-type_document_id">
                            <b-form-select id="documententry-type_document_id"
                            size="sm"
                            :disabled="docRead"
                            :options="typedocuments" 
                            :state="typeDocumentState"
                            v-model="documententry.type_document_id" />
                             <b-form-invalid-feedback  id="input-live-type_document_id">
                                Falta Informar o Tipo do documento...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                    </b-col> 
                    <b-col md="2" sm="12">
                        <b-form-group label="Data de Emissão:" label-for="documententry-issue_date">
                        <b-form-input 
                            id="documententry-issue_date" 
                            type="date"
                            v-model="documententry.issue_date" 
                            :state="issueDateState"
                            :readonly="docRead"
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 
                    <b-col md="2" sm="12">
                            <b-form-group label="Nº de Lançamento:" label-for="documententry-document_number">
                            <b-form-input id="documententry-document_number" 
                                v-model="documententry.document_number" 
                                :readonly="docRead"
                                :state="documentNumberState"
                                type="number"
                                size="sm"
                                />
                            <b-form-invalid-feedback  id="input-live-document_number">
                                    Falta Informar o número do documento...                            
                            </b-form-invalid-feedback >    
                            </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                            <b-form-group 
                                label="Status:" 
                                label-for="documententry-document_status_id">
                            <b-form-select 
                                id="documententry-document_status_id"
                                size="sm"
                                :readonly="docRead"
                                disabled
                                :options="documentstatus" 
                                v-model="documententry.document_status_id" />
                            </b-form-group>
                    </b-col>
               </b-row>
               <b-row>
                    <b-col md="1" sm="2">
                        <b-form-group label="ID" label-for="entity-id">
                        <b-form-input id="entity-id" type="text"
                            v-model="documententry.entity_id"
                            @input="[setEntity(),getAdvancedValue()]"
                            :readonly="docRead"
                            v-on:keyup.enter="openModalEntity"
                            :state="entityState"
                            size="sm"
                            placeholder="Código..." /> 
                            <b-form-invalid-feedback  id="input-live-entity_id">
                                    Falta Informar...
                            </b-form-invalid-feedback >
                        </b-form-group>
                    </b-col>    
                         <b-link v-b-modal.modalEntity class="fa fa-search mt-4" ></b-link > 
                    <b-col md="6" sm="8">
                        <b-form-group 
                            label="Nome:" 
                            label-for="entity-name_entity">
                        <b-form-input 
                            id="entity-name_entity" 
                            type="text"
                            v-model="entity.name_entity"
                            size="sm"
                            :readonly= 'true'
                            placeholder="Nome..." />
                        </b-form-group>
                    </b-col> 
                    <b-col md="2" sm="2">
                        <b-form-group 
                            label="CPF/CNPJ:" 
                            label-for="entity-cnpj_cpf">
                        <b-form-input 
                            id="entity-cnpj_cpf" 
                            type="text"
                            v-model="entity.cnpj_cpf"
                            size="sm"
                            :readonly= 'true'
                            placeholder="" />
                        </b-form-group>
                    </b-col>   
                    <b-link 
                        v-b-modal.modalRegisterEntity 
                        class="fa fa-plus mt-4" >
                    </b-link >  
                    </b-row>
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Condição de Pagamento:" 
                                label-for="documententry-condition_payment_receipt_id">
                            <b-form-select 
                                id="documententry-condition_payment_receipt_id"
                                size="sm"
                                :disabled="docRead"
                                :options="conditionpaymentreceipts" 
                                :state="conditionPaymentReceiptState"
                                v-model="documententry.condition_payment_receipt_id" />
                            <b-form-invalid-feedback  id="input-live-condition_payment_receipt_id">
                                    Falta Informar a Condição de Pagamento/Recebimento...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group 
                            label="Centro de Custo/Receita:" label-for="documententry-cost_center_id">
                            <b-form-select id="documententry-cost_center_id"
                            size="sm"
                            :disabled="docRead"
                            :options="costcenters" 
                            :state="costCenterState"
                            v-model="documententry.cost_center_id" />
                             <b-form-invalid-feedback  id="input-live-cost_center_id">
                                    Falta Informar o Centro de Custo/Receita...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Valor:" 
                                label-for="documententry-document_value">
                            <b-form-input 
                                id="documententry-document_value" 
                                v-model="documententry.document_value" 
                                type="number"
                                size="sm"
                                :readonly="docRead"
                                :state="documentValueState"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                                <b-form-invalid-feedback  id="input-live-release_value">
                                    Falta Informar o Valor do Documento...                            
                                </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Saldo Adiantamento:" 
                                label-for="documententry-advanced_value">
                            <b-form-input id="documententry-advanced_value" 
                                v-model="documententry.advanced_value" 
                                type="number"
                                size="sm"
                                :readonly="true"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                     <b-row>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Custo:" 
                                label-for="documententry-type_cost_id">
                            <b-form-select 
                                id="documententry-type_cost_id"
                                size="sm"
                                :disabled="docRead"
                                :state="typeCostState"
                                :options="typecosts" 
                                v-model="documententry.type_cost_id" />
                            <b-form-invalid-feedback  id="input-live-type_cost_id">
                                    Falta Informar o Tipo de Custo...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="2" sm="12">
                            <b-form-group 
                                label="Operação:" 
                                label-for="documententry-operation_id">
                            <b-form-select 
                                id="documententry-operation_id"
                                @input="loadOperationsLevelOnes"
                                size="sm"
                                :disabled="docRead"
                                :options="operations" 
                                :state="operationState"
                                v-model="documententry.operation_id" />
                            <b-form-invalid-feedback  id="input-live-operation_id">
                                    Falta Informar a Operação...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="1º Nível:" 
                                label-for="documententry-operation_level_one_id">
                            <b-form-select 
                                id="documententry-operation_level_one_id"
                                @input="loadOperationsLevelTwos"
                                :disabled="docRead"
                                size="sm"
                                :state="operationLevelOneState"
                                :options="operationslevelones" 
                                v-model="documententry.operation_level_one_id" />
                            <b-form-invalid-feedback  id="input-live-operation_level_one_id">
                                    Falta Informar o 1º Nível da Operação ...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                        <b-col md="5" sm="12">
                            <b-form-group 
                            label="2º Nível:" 
                            label-for="documententry-operation_level_two_id">
                            <b-form-select id="documententry-operation_level_two_id"
                            size="sm"
                            :disabled="docRead"
                            :state="operationLevelTwoState"
                            :options="operationsleveltwos" 
                            v-model="documententry.operation_level_two_id" />
                            <b-form-invalid-feedback  id="input-live-operation_level_two_id">
                                    Falta Informar o 2º Nível da Operação ...                            
                            </b-form-invalid-feedback >
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group 
                                label="Chave de Acesso:" 
                                label-for="documententry-provision_description">
                                <b-form-input 
                                    id="documententry-provision_description" 
                                    type="text"     
                                    :readonly="docRead"   
                                    v-model="documententry.key_access"
                                    placeholder="Chave de Acesso..." />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="7" sm="12">
                            <b-form-group 
                                label="Observação:" 
                                label-for="documententry-comments">
                            <b-form-textarea 
                                id="documententry-comments"
                                :rows="2"
                                :max-rows="3"
                                size="sm"
                                :readonly="docRead"
                                v-model="documententry.comments"
                                placeholder="" />
                            </b-form-group>
                        </b-col>
                         <b-col md="5" sm="12">
                        <b-card
                            class="bg-secondary text-light mb-2"
                            border-variant="Secondary"
                            header="Informações do Registro"
                            header-bg-variant="Secondary"
                            header-text-variant="black"
                            align="center">
                        <b-card-text>
                            <strong> Registrado em: </strong>  {{this.formatDateTimeReg(this.documententry.register)}} |
                            <strong> Alterado em: </strong>  {{this.documententry.update_date ? this.formatDateTimeReg(this.documententry.update_date) : ''}}
                        </b-card-text>
                        <b-card-text>
                            <strong> Valor Total: </strong> {{this.documententry.document_value}} | 
                            <strong> Valor Parcela(s): </strong> {{this.formatValue(this.splotSum[this.splotSum.length - 1])}} |
                            <strong> Valor Items(s): </strong> {{this.formatValue(this.itemSum[this.itemSum.length -1])}} |
                            <strong> Valor Retenções: </strong> {{this.formatValue(this.retentionSum[this.retentionSum.length -1])}}
                        </b-card-text>
                        </b-card>
                    </b-col>
                    </b-row>
         </b-form>
            <b-row>
            <b-col xs="12">
                <b-button   
                    size="lq" 
                    variant="dark"  
                    v-show="!docRead"
                    class="fa fa-save"
                    @click="saveDocumentEntry">
                    
                    </b-button>
                <b-button  
                    size="lq" 
                    variant="dark" 
                    title="Retornar tela de consulta"
                    class="ml-2 fa fa-reply"
                    @click="goback">
                </b-button>  
                <b-button 
                    size="lq" 
                    variant="dark" 
                    title="Validar registro"
                    class="ml-2  fa fa-check"
                    v-show="!this.documententry.checkvalueplot" 
                    v-if="this.documententry.id > 0"
                    @click="validatedValueSplot()">
                </b-button>  
                <b-button   
                    size="lq" 
                    variant="dark" 
                    class="ml-2" 
                    v-show="this.documententry.checkvalueplot" 
                    v-if="this.documententry.document_status_id === 1"
                    @click="[confirmDocumentEntry()]">
                    Confirmar
                </b-button>      
                <b-button
                     size="lq" 
                     variant="dark" 
                     class="ml-2" 
                     v-show="this.documententry.checkvalueplot" 
                     v-if="this.documententry.document_status_id === 2"
                    @click="[confirmDocumentEntry()]">
                    Deconfirmar
                </b-button>      
            </b-col>
        </b-row>
        <hr>
         <b-card 
            bg-variant="light" 
            text-variant="dark"
            no-body 
            v-show="this.documententry.id > 0 ? true : false">
            <b-tabs  
                card 
                small>
                <b-tab title="Item" active>
                <b-row>                     
                    <b-col md="2" sm="12">
                        <b-button 
                             title = "Adicionar Item (Sem Ordem de Compra)" 
                            size="lq" 
                            @click="setNewItem"
                            v-b-modal.modalDocumentEntryItem 
                            v-show="this.documententry.document_status_id === 1 && this.documententry.id > 0 ? true : false" 
                            variant="dark" 
                            class="mr-2 mb-2" 
                        > <i class="fa fa-plus"></i></b-button>  
                        <b-button 
                             
                            title = "Adicionar Item (Com Ordem de Compra) " 
                            size="lq" 
                            v-show="this.documententry.document_status_id === 1 && this.documententry.id > 0 ? true : false"  
                            variant="dark" 
                            class="mr-2 mb-2" 
                        > <i class="fa fa-reply-all"></i></b-button>
                    </b-col>  
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                
                        <transition  
                                    name="slide" 
                                    type="animation" 
                                    appear> 
                            <b-table 
                                    class="table-responsive" 
                                    hover key="slide" 
                                    striped 
                                    :items="documententrysitems" 
                                    :fields="fieldsDocumentEntryItem"> 
                                <template v-slot:cell(actions)="data">
                                    <b-button 
                                         
                                        title = "Editar registro" 
                                        v-show="!docRead" 
                                        v-b-modal.modalDocumentEntryItem  
                                        size="sm" 
                                        variant="light" 
                                        @click="loadDocumentEntrysItem(data.item)" 
                                        class="mr-2 mt-2">
                                        <i class="fa fa-pencil"></i>
                                    </b-button>
                                    <b-button 
                                         title = "Excluir registro" 
                                        size="sm" 
                                        v-show="!docRead"  
                                        variant="light" 
                                        @click="modeItem = 'remove'" 
                                        class="mr-2 mt-2"
                                        v-if="modeItem === 'insert'"
                                    >
                                        <i class="fa fa-trash"></i>
                                    </b-button>
                                    <b-button
                                        title = "Imposto" 
                                        variant="light" 
                                        class="mr-2 mt-2"
                                         v-b-modal.modalDocumentEntryItemTaxs
                                    >
                                         <i class="fa fa-server"></i>
                                    </b-button>
                                    <b-button 
                                         
                                        size="sm" 
                                        variant="success" 
                                        @click="[removeItem(data.item),modeItem = 'insert']" 
                                        class="mr-2 mt-2"
                                        v-if="modeItem === 'remove'"
                                    >
                                        <i class="fa fa-check"></i>
                                    </b-button>
                                    <b-button 
                                         
                                        size="sm" 
                                        variant="danger" 
                                        @click="modeItem = 'insert'" 
                                        class="mr-2 mt-2"
                                        v-if="modeItem === 'remove'"
                                    >
                                        <i class="fa fa-times"></i>
                                    </b-button>
                                    <span class="mr-2 mt-2"  v-if="modeItem === 'remove'" > Deseja Excluir o registro? </span>
                                </template>
                            </b-table>
                        </transition>
                        </b-col>
                    </b-row>
                </b-tab>
                    <b-tab title="Parcela(s)">
                        <b-row>                     
                            <b-col md="2" sm="12">
                                <b-button 
                                     
                                    title = "Adicionar Parcela" 
                                    size="sm" 
                                    v-b-modal.modalPlots 
                                    v-show="this.documententry.document_status_id === 1 && this.documententry.id > 0 ? true : false" variant="outline-success" class="mr-2 mb-2" 
                                > <i class="fa fa-plus"></i></b-button>
                                <b-button 
                                     
                                    title = "Parcela(s) com Base na Condição de Pag/Rec. " 
                                    v-b-modal.modalSplotConditionPayment 
                                    size="sm" 
                                    v-show="this.documententry.document_status_id === 1  && this.documententry.id > 0 ? true : false"  variant="outline-info" class="mr-2 mb-2" 
                                > <i class="fa fa-reply-all"></i></b-button>
                            </b-col>  
                        </b-row>
                        <b-row>
                              <b-col md="12" sm="12">
                                <transition  
                                    name="slide" 
                                    type="animation" 
                                    appear> 
                                    <b-table 
                                        class="table-responsive" 
                                        hover 
                                        key="slide" 
                                        striped 
                                        :items="documententrysplots" 
                                        :fields="fieldsPlot"> 
                                        <template v-slot:cell(actions)="data">
                                            <b-button 
                                                 
                                                title = "Editar registro" 
                                                v-show="!docRead" 
                                                v-b-modal.modalPlots  
                                                size="sm" 
                                                variant="outline-warning" 
                                                @click="loadDocumentEntrysPlot(data.item)" class="mr-2 mt-2">
                                                <i class="fa fa-pencil"></i>
                                            </b-button>
                                            <b-button  size="sm" v-show="!docRead"  variant="outline-danger" @click="modePlot = 'remove'" class="mr-2 mt-2"
                                                v-if="modePlot === 'insert'"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="success" @click="[removePlot(data.item),modePlot = 'insert']" class="mr-2 mt-2"
                                                v-if="modePlot === 'remove'"
                                            >
                                                <i class="fa fa-check"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="danger" @click="modePlot = 'insert'" class="mr-2 mt-2"
                                                v-if="modePlot === 'remove'"
                                            >
                                                <i class="fa fa-times"></i>
                                            </b-button>
                                            <span class="mr-2 mt-2"  v-if="modePlot === 'remove'" > Deseja Excluir o registro? </span>
                                        </template>
                                    </b-table>
                                </transition>
                              </b-col>
                         </b-row>
                     </b-tab>
                      <b-tab title="Retenções">
                           <b-row>
                              <b-col md="12" sm="12">
                                <b-button 
                                     
                                    size="sm" 
                                    v-b-modal.modalRetention 
                                    @click="setNewRetention" 
                                    v-show="!docRead ? true : false" 
                                    variant="outline-success" 
                                    class="mr-2 mb-2" 
                                > <i class="fa fa-plus"></i></b-button>
                                <transition  
                                    name="slide" 
                                    type="animation" 
                                    appear> 
                                    <b-table class="table-responsive" sticky-header head-variant="light" hover key="slide" striped :items="documententrysretentions" :fields="fieldsRetention"> 
                                        <template v-slot:cell(actions)="data">
                                            <b-button  title = "Editar registro" v-show="!docRead ? true : false" v-b-modal.modalRetention  size="sm" variant="warning" @click="loaddocumententrysRetention(data.item)" class="mr-2 mt-2">
                                                <i class="fa fa-pencil"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="danger" v-show="!docRead ? true : false" @click="modeRetention = 'remove'" class="mr-2 mt-2"
                                                v-if="modeRetention === 'insert'"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="success" @click="[removeRetention(data.item),modeRetention = 'insert']" class="mr-2 mt-2"
                                                v-if="modeRetention === 'remove'"
                                            >
                                                <i class="fa fa-check"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="danger" @click="modeRetention = 'insert'" class="mr-2 mt-2"
                                                v-if="modeRetention === 'remove'"
                                            >
                                                <i class="fa fa-times"></i>
                                            </b-button>
                                            <span class="mr-2 mt-2"  v-if="modeRetention === 'remove'" > Deseja Excluir o registro? </span>
                                        </template>
                                    </b-table>
                                </transition>
                              </b-col>
                         </b-row>
                     </b-tab>
                     <b-tab title="Imposto(s)">
                          <b-row>
                              <b-col md="12" sm="12">
                                <b-button 
                                     
                                    size="sm" 
                                    v-b-modal.modalTax 
                                    @click="setNewTax" 
                                    v-show="!docRead ? true : false"
                                    variant="outline-success" 
                                    class="mr-2 mb-2" 
                                > <i class="fa fa-plus"></i></b-button>
                                <transition  name="slide" type="animation" appear> 
                                    <b-table class="table-responsive" sticky-header head-variant="light" hover key="slide" striped :items="documententrystaxs" :fields="fieldsTax"> 
                                        <template v-slot:cell(actions)="data">
                                            <b-button  title = "Editar registro" v-b-modal.modalTax  size="sm" variant="warning" @click="loaddocumententrysTax(data.item)" class="mr-2 mt-2">
                                                <i class="fa fa-pencil"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="danger" @click="modeTax = 'remove'" class="mr-2 mt-2"
                                                v-if="modeTax === 'insert'"
                                            >
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="success" @click="[removeTax(data.item),modeTax = 'insert']" class="mr-2 mt-2"
                                                v-if="modeTax === 'remove'"
                                            >
                                                <i class="fa fa-check"></i>
                                            </b-button>
                                            <b-button  size="sm" variant="danger" @click="modeTax = 'insert'" class="mr-2 mt-2"
                                                v-if="modeTax === 'remove'"
                                            >
                                                <i class="fa fa-times"></i>
                                            </b-button>
                                            <span class="mr-2 mt-2"  v-if="modeTax === 'remove'" > Deseja Excluir o registro? </span>
                                        </template>
                                    </b-table>
                                </transition>
                              </b-col>
                         </b-row>
                     </b-tab>
                    
                </b-tabs>
          </b-card>
          <b-modal 
            id="modalPlots"
            ref="modal"
            title="Parcelas"
            title-tag = "h6"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="savePlot"
            >
                <b-form>
                    <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Data de Vencto:" 
                                label-for="documententrysplot-due_date">
                            <b-form-input 
                                id="documententrysplot-due_date" 
                                type="date"
                                v-model="documententrysplot.due_date" 
                                size="sm"
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Valor Parcela:" 
                                label-for="documententrysplot-portion_value">
                            <b-form-input 
                                id="documententrysplot-portion_value" 
                                v-model="documententrysplot.portion_value" 
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                         <b-col md="8" sm="12">
                            <b-form-group 
                            label="Forma de Pagamento/Recebimento:" label-for="documententrysplot-settlement_form_id">
                            <b-form-select id="documententrysplot-settlement_form_id"
                            size="sm"
                            :options="settlementforms" v-model="documententrysplot.settlement_form_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
            <b-modal id="modalEntity"
                    ref="modal"
                    title-tag = "h6"
                    size="lg"
                    title="Consulta de Cliente/Fornecedor"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    @ok="setSearchEntity"
                    >
                    <EntitySearchModal 
                    @setEntityId="entity_id=$event"
                    @setEntityName="entity.name_entity=$event"
                    @setEntityCnpjCpf="entity.cnpj_cpf=$event"
                    />
            </b-modal>
         <b-modal id="modalItem"
                    ref="modal"
                     hide-footer
                    title-tag = "h6"
                    @shown="focusModalItem"
                    size="lg"
                    title="Consulta de Item"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    >
                    <b-form>
                        <b-row>
                            <b-col md="8" sm="8">
                                <b-form-group 
                                    label="Descrição:" 
                                    label-for="item-complements_name">
                                <b-form-input 
                                    id="item-complements_name" 
                                    type="text"
                                    v-model="item.complements_name"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="Nome..." />
                                </b-form-group>
                            </b-col> 
                            <b-col md="2" sm="2">
                                <b-form-group label="Und:" label-for="entity-initials">
                                <b-form-input 
                                    id="entity-initials" 
                                    type="text"
                                    v-model="item.initials"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="" />
                                </b-form-group>
                            </b-col>  
                        </b-row>
                        <b-row>
                            <div class="col-sm-8">
                                <div class="form-group">
                                    <label 
                                        class="control-label"> 
                                        <i class="fa fa-search"></i>  
                                        Pesquisar 
                                    </label> 
                                    <b-button 
                                         
                                        size="sm" 
                                        class=" ml-2 mb-2 fa fa-search" 
                                        @click="[loadItems(),showItem = !showItem]" 
                                        variant="secondary" ></b-button>
                                    <input 
                                        type="text" 
                                        icon="search" 
                                        v-model="searchItem" 
                                        ref="focusItem"
                                        v-on:keyup.enter="[loadItems(),showItem =true]"
                                        placeholder="Informe a descrição" 
                                        class="form-control">
                                    <b-form-select 
                                        id="item-group_item_id"
                                        class="mt-2"
                                        size="sm"
                                        :options="groupitems" 
                                        @input="loadItems"
                                        v-model="group_item_id" />    
                                </div>
                            </div>
                        </b-row>   
                        <b-table 
                            class="table-responsive" 
                            hover 
                            striped 
                            v-show="showItem" 
                            :per-page="perPage" 
                            :current-page="currentPage" 
                            :items="filteredListItems" 
                            :fields="fieldsItems">
                            <template 
                                v-slot:cell(actions)="data">
                                    <b-button 
                                         
                                        title = "Selecionar o registro" 
                                        size="sm" 
                                        variant="secondary" 
                                        @click="[setItemSearch(data.item),showItem= !showItem,hideModal()]" class="mr-2 mt-2">
                                        <i class="fa fa-check-square-o"></i>
                                    </b-button>
                                </template>   
                        </b-table>
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rowsItems"
                            :per-page="perPage"
                            aria-controls="my-table"
                        ></b-pagination> 
                    </b-form>
        </b-modal>
        <b-modal id="modalSplotConditionPayment"
            ref="modal"
            title-tag = "h6"
            title="Informe o meio de Pagamento/Recebimento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="insertDocumentEntrySplotConfditionPayment"
            >
            <b-row>
                <b-col md="10" sm="12">
                    <b-form-group 
                        label="Forma de Pagamento" 
                        label-for="documententry-settlement_form_id">
                    <b-form-select 
                        id="documententry-settlement_form_id"
                        size="sm"
                        :options="settlementforms" 
                        v-model="documententrysplot.settlement_form_id" />
                    </b-form-group>
                </b-col>
         </b-row>
        </b-modal>
        <b-modal id="modalDocumentEntryItem"
                ref="modal"
                size="xl"
                title-tag = "h6"
                @shown="focusModalEntryItem"
                title="Item sem Ordem de Compra"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
                @ok="saveDocumentEntryItem"
            >
           <b-form>

                <b-row>
                    <input 
                        id="documententrysitem-item_stock_id" 
                        type="hidden" 
                        v-model="documententrysitem.item_stock_id" />
                    <b-col md="2" sm="2">
                        <b-form-group 
                            label="ID:" 
                            label-for="documententrysitem-item_id">
                        <b-form-input 
                            id="documententrysitem-item_id" 
                            type="text"
                            ref="focusEntryItem"
                            v-model="documententrysitem.item_id"
                            @input="[setItem(),loadItemsStock()]"
                            v-on:keyup.enter="documententrysitem&&documententrysitem.item_id > 0 ? focusModalEntryItemQuantity() : openModalItem()"
                            size="sm"
                            placeholder="Código..." />
                        </b-form-group>
                        </b-col> 
                            <b-link 
                                class="fa fa-search mt-4" 
                                v-b-modal.modalItem 
                                @click="[loadItems(),showItem=true]" 
                            >
                            </b-link >    
                        <b-col md="8" sm="8">
                                <b-form-group 
                                    label="Nome:" 
                                    label-for="item-complements_name">
                                <b-form-input 
                                    id="item-complements_name" 
                                    type="text"
                                    v-model="item.complements_name"
                                    size="sm"
                                    :readonly= 'true'
                                    placeholder="Nome..." />
                                </b-form-group>
                        </b-col>        
                        <b-col md="1" sm="2">
                            <b-form-group 
                                label="Unid:" 
                                abel-for="item-initials">
                            <b-form-input 
                                id="item-initials" 
                                type="text"
                                v-model="item.initials"
                                size="sm"
                                :readonly= 'true'
                                placeholder="Unid." />
                            </b-form-group>
                        </b-col> 
                    </b-row>
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Qtde:" 
                                label-for="documententrysitem-entry_quantity">
                            <b-form-input 
                                id="documententrysitem-entry_quantity" 
                                v-model="documententrysitem.entry_quantity" 
                                ref="focusEntryItemQuantity"
                                @input="ItemValue"
                                v-on:keyup.enter="focusModalEntryItemValueUnit"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Valor Unitário:" 
                                label-for="documententrysitem-entry_value_unit">
                            <b-form-input 
                                id="documententrysitem-entry_value_unit" 
                                v-model="documententrysitem.entry_value_unit" 
                                ref="focusEntryItemValueUnit"
                                 @input="[ItemValue(),ItemUnitFinalValue()]"
                                v-on:keyup.enter="focusModalEntryItemValueDesc"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Valor Desconto" 
                                label-for="documententrysitem-entry_value_discount">
                            <b-form-input 
                                id="documententrysitem-entry_value_discount" 
                                v-model="documententrysitem.entry_value_discount" 
                                @input="[ItemValue(),ItemUnitFinalValue()]"
                                ref="focusEntryItemValueDesc"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Valor Total:" 
                                label-for="documententrysitem-entry_value_total">
                            <b-form-input 
                                id="documententrysitem-entry_value_total" 
                                v-model="documententrysitem.entry_value_total" 
                                type="number"
                                size="sm"
                                :readonly= 'true'
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                      <b-card no-body>
                         <b-tabs card >
                             <b-tab title="Apontamento do Estoque/Custo" active> 
                                 <b-row>
                                     <b-col md="8" sm="12">
                                        <b-form-group 
                                            label="Estoque:" 
                                            label-for="documententrysitem-item_stock_id">
                                        <b-form-select id="documententrysitem-item_stock_id"
                                            size="sm"
                                            :options="items_stock" 
                                            v-model="documententrysitem.item_stock_id" />
                                        </b-form-group>
                                    </b-col>
                                 </b-row>
                                 <b-row>
                                    <b-col md="2" sm="2">
                                        <b-form-group 
                                            label="ID" 
                                            label-for="documententrysitem.equipment-id">
                                        <b-form-input 
                                            id="documententrysitem.equipment-id" 
                                            type="text"
                                            v-model="documententrysitem.equipment_id"
                                            @input="setEquipment()"
                                            size="sm"
                                            placeholder="Código..." /> 
                                        </b-form-group>
                                    </b-col>    
                                        <b-link 
                                            v-b-modal.modalEquipment 
                                            class="fa fa-search mt-4" >
                                        </b-link > 
                                        <b-col md="6" sm="8">
                                        <b-form-group 
                                            label="Equipamento:" 
                                            label-for="equipment-name_equipment">
                                        <b-form-input 
                                            id="equipment-name_equipment" 
                                            type="text"
                                            v-model="equipment.name_equipment"
                                            size="sm"
                                            :readonly= 'true'
                                            placeholder="Nome..." />
                                        </b-form-group>
                                    </b-col> 
                                    <b-col md="3" sm="2">
                                        <b-form-group 
                                            label="Código do Equipamento:" 
                                            label-for="equipment-internal_code_equipment">
                                        <b-form-input 
                                            id="equipment-internal_code_equipment" 
                                            type="text"
                                            v-model="equipment.internal_code_equipment"
                                            size="sm"
                                            :readonly= 'true'
                                            placeholder="" />
                                        </b-form-group>
                                    </b-col>  
                                 </b-row>
                             </b-tab>

                         </b-tabs>
                      </b-card>   
           </b-form>

        </b-modal>
        <b-modal id="modalRegisterEntity"
            hide-footer
            ref="modal"
            size="xl"
            title-tag = "h6"
            title="Registro de Cliente/Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <EntityModal/>
        </b-modal>
         <b-modal id="modalRetention"
            ref="modal"
            title-tag = "h6"
            title="Retenção"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveRetention"
            >
                <b-form>
                    <b-row>
                        <b-col md="8" sm="12">
                            <b-form-group 
                                label="Retenção:" 
                                label-for="documententrysretention-retention_id">
                            <b-form-select 
                                id="documententrysretention-retention_id"
                                size="sm"
                                :options="retentions" 
                                v-model="documententrysretention.retention_id" />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">    
                            <b-form-group 
                                    label="%:" 
                                    label-for="documententrysretention-percent">
                                <b-form-input 
                                    id="documententrysretention-percent" 
                                    v-model="documententrysretention.percent" 
                                    @input="retentionValue"
                                    type="number"
                                    size="sm"
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                     <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Data base:" 
                                label-for="documententrysretention-base_date">
                            <b-form-input 
                                id="documententrysretention-base_date" 
                                type="date"
                                v-model="documententrysretention.base_date" 
                                size="sm"
                            />
                            </b-form-group>
                        </b-col>
                         <b-col md="4" sm="12">
                            <b-form-group 
                                label="Data Vencto:" 
                                label-for="documententrysretention-due_date">
                            <b-form-input 
                                id="documententrysretention-due_date" 
                                type="date"
                                v-model="documententrysretention.due_date" 
                                size="sm"
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Valor Base:" 
                                label-for="documententrysretention-base_retention_value">
                            <b-form-input 
                                id="documententrysretention-base_retention_value" 
                                v-model="documententrysretention.base_retention_value" 
                                @input="retentionValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                         <b-col md="4" sm="12">
                            <b-form-group 
                                label="Valor Retido:" 
                                label-for="documententrysretention-retention_value">
                            <b-form-input 
                                id="documententrysretention-retention_value" 
                                v-model="documententrysretention.retention_value" 
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
             <b-modal id="modalTax"
                ref="modal"
                title-tag = "h6"
                title="Imposto"
                size="lq"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
                @ok="saveTax"
            >
                <b-form>
                    <b-row>
                         <b-col md="8" sm="12">
                            <b-form-group 
                                label="Imposto:" 
                                label-for="documententrystax-tax_id">
                            <b-form-select 
                                id="documententrystax-tax_id"
                                size="sm"
                                :options="taxs" 
                                v-model="documententrystax.tax_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>  
                        <b-col md="8" sm="12">
                            <b-form-group 
                                label="Natureza de Entrada:" 
                                label-for="documententrystax-nature_inbound_operation_id">
                            <b-form-select 
                                id="documententrystax-nature_inbound_operation_id"
                                size="sm"
                                :options="natureinboundoperations" 
                                v-model="documententrystax.nature_inbound_operation_id" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                     <b-row>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Data base:" 
                                label-for="documententrystax-base_date">
                            <b-form-input 
                                id="documententrystax-base_date" 
                                type="date"
                                v-model="documententrystax.base_date" 
                                size="sm"
                            />
                            </b-form-group>
                        </b-col>
                        <b-col md="4" sm="12">
                            <b-form-group 
                                label="Valor Base:" 
                                label-for="documententrystax-base_tax_value">
                            <b-form-input 
                                id="documententrystax-base_tax_value" 
                                v-model="documententrystax.base_tax_value" 
                                @input="taxValue"
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">    
                            <b-form-group 
                                label="%:" 
                                label-for="documententrystax-percent">
                                <b-form-input 
                                    id="documententrystax-percent" 
                                    v-model="documententrystax.percent" 
                                    @input="taxValue"
                                    type="number"
                                    size="sm"
                                    step="0.02"
                                    pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                    />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Vr.Imposto:" 
                                label-for="documententrystax-tax_value">
                            <b-form-input 
                                id="documententrystax-tax_value" 
                                v-model="documententrystax.tax_value" 
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col md="3" sm="12">
                            <b-form-group 
                                label="Vr.Isento:" 
                                label-for="documententrystax-tax_free_value">
                            <b-form-input 
                                id="documententrystax-tax_free_value" 
                                v-model="documententrystax.tax_free_value" 
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                         <b-col md="3" sm="12">
                            <b-form-group 
                                label="Vr.Outros:" 
                                label-for="documententrystax-tax_others_value">
                            <b-form-input 
                                id="documententrystax-tax_others_value" 
                                v-model="documententrystax.tax_others_value" 
                                type="number"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
            <b-modal id="modalEquipment"
                    ref="modal"
                    title-tag = "h6"
                    size="lg"
                    title="Consulta de Equipamento"
                    :header-bg-variant="headerBgVariant"
                    :header-text-variant="headerTextVariant"
                    :body-bg-variant="bodyBgVariant"
                    :body-text-variant="bodyTextVariant"
                    @ok="setSearchEquipment"
                    >
                    <EquipamentSearchModal 
                        @setEquipmentId="equipment_id=$event"
                        @setEquipmentName="equipment.name_equipment=$event"
                        @setEntityInternalCode="equipment.internal_code_equipment=$event"
                />
            </b-modal>
            <b-modal id="modalDocumentEntryItemTaxs"
                ref="modal"
                size="lq"
                title-tag = "h6"
                @shown="focusModalEntryItem"
                title="Imposto (Item)"
                :header-bg-variant="headerBgVariant"
                :header-text-variant="headerTextVariant"
                :body-bg-variant="bodyBgVariant"
                :body-text-variant="bodyTextVariant"
                @ok="saveDocumentEntryItemTax"
            >
           <b-form>
                <b-row>
                    <input 
                        id="documententrysitemstax-id" 
                        type="hidden" 
                        v-model="documententrysitemstax.id" />
                      <b-card no-body>
                         <b-tabs card >
                             <b-tab title="ICMS" active> 
                                <b-row>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Base de Cálculo:" 
                                            label-for="documententrysitemstax-icms_v_bc">
                                        <b-form-input 
                                            id="documententrysitemstax-icms_v_bc" 
                                            v-model="documententrysitemstax.icms_v_bc" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="%:" 
                                            label-for="documententrysitemstax-icms_p_icms">
                                        <b-form-input 
                                            id="documententrysitemstax-icms_p_icms" 
                                            v-model="documententrysitemstax.icms_p_icms" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                     <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Valor:" 
                                            label-for="documententrysitemstax-icms_v_icms">
                                        <b-form-input 
                                            id="documententrysitemstax-icms_v_icms" 
                                            v-model="documententrysitemstax.icms_v_icms" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                 </b-row>
                                  <b-row>
                                     <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Base de Cálculo (ST):" 
                                            label-for="documententrysitemstax-icms_bc_st">
                                        <b-form-input 
                                            id="documententrysitemstax-icms_bc_st" 
                                            v-model="documententrysitemstax.icms_bc_st" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="% (ST):" 
                                            label-for="documententrysitemstax-icms_p_icms_st">
                                        <b-form-input 
                                            id="documententrysitemstax-icms_p_icms_st" 
                                            v-model="documententrysitemstax.icms_p_icms_st" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                     <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Valor (ST):" 
                                            label-for="documententrysitemstax-icms_v_icms_st">
                                        <b-form-input 
                                            id="documententrysitemstax-icms_v_icms_st" 
                                            v-model="documententrysitemstax.icms_v_icms_st" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                 </b-row>
                                 
                             </b-tab>
                            <b-tab title="IPI" >
                                 <b-row>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Base de Cálculo:" 
                                            label-for="documententrysitemstax-ipi_v_bc">
                                        <b-form-input 
                                            id="documententrysitemstax-ipi_v_bc" 
                                            v-model="documententrysitemstax.ipi_v_bc" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="%:" 
                                            label-for="documententrysitemstax-ipi_p_ipi">
                                        <b-form-input 
                                            id="documententrysitemstax-ipi_p_ipi" 
                                            v-model="documententrysitemstax.ipi_p_ipi" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                     <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Valor:" 
                                            label-for="documententrysitemstax-ipi_v_ipi">
                                        <b-form-input 
                                            id="documententrysitemstax-ipi_v_ipi" 
                                            v-model="documententrysitemstax.ipi_v_ipi" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                 </b-row>
                            </b-tab> 
                            <b-tab title="PIS" >
                                 <b-row>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Base de Cálculo:" 
                                            label-for="documententrysitemstax-pis_v_bc">
                                        <b-form-input 
                                            id="documententrysitemstax-pis_v_bc" 
                                            v-model="documententrysitemstax.pis_v_bc" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="%:" 
                                            label-for="documententrysitemstax-pis_p_pis">
                                        <b-form-input 
                                            id="documententrysitemstax-pis_p_pis" 
                                            v-model="documententrysitemstax.pis_p_pis" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                     <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Valor:" 
                                            label-for="documententrysitemstax-pis_v_pis">
                                        <b-form-input 
                                            id="documententrysitemstax-pis_v_pis" 
                                            v-model="documententrysitemstax.pis_v_pis" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                 </b-row>
                            </b-tab> 
                            <b-tab title="COFINS" >
                                <b-row>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Base de Cálculo:" 
                                            label-for="documententrysitemstax-cofins_v_bc">
                                        <b-form-input 
                                            id="documententrysitemstax-cofins_v_bc" 
                                            v-model="documententrysitemstax.cofins_v_bc" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="%:" 
                                            label-for="documententrysitemstax-cofins_p_cofins">
                                        <b-form-input 
                                            id="documententrysitemstax-cofins_p_cofins" 
                                            v-model="documententrysitemstax.cofins_p_cofins" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                     <b-col md="4" sm="12">
                                        <b-form-group 
                                            label="Valor:" 
                                            label-for="documententrysitemstax-cofins_v_cofins">
                                        <b-form-input 
                                            id="documententrysitemstax-cofins_v_cofins" 
                                            v-model="documententrysitemstax.cofins_v_cofins" 
                                            type="number"
                                            size="sm"
                                            step="0.02"
                                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                                            />
                                        </b-form-group>
                                    </b-col>
                                 </b-row>
                            </b-tab>

                         </b-tabs>
                      </b-card>   
                </b-row>
           </b-form>

        </b-modal>

    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import { baseApiUrl,showError } from '@/global'
import axios from 'axios'
import EntityModal from '../util/EntityModal'
import EntitySearchModal from '../util/EntitySearchModal'
import EquipamentSearchModal from '../util/EquipamentSearchModal'
var moment = require('moment-timezone')

export default {
      name: 'RecordDocumentEntry',
      components: {PageTitle,EntityModal,EntitySearchModal,EquipamentSearchModal },
      data: function() {
          return {
                mode: 'save',
                modeRetention: 'insert',
                modeTax: 'insert',
                modeItem: 'insert',
                modePlot: 'insert',
                entity_id: null,
                equipment_id: null,
                docRead: false,
                showItemStock: false,
                showEntity: false,
                showItem: false,
                group_item_id:null,
                searchItem: '',
                documentstatus:[],
                documententry: {},
                documententrysretention: {},
                documententrysretentions:[],
                documententrystax: {},
                documententrystaxs:[],
                documententrysitem: {},
                documententrysitems:[],
                documententrysplot: {},
                documententrysplots:[],
                documententrysitemstax:{},
                retentions: [],
                taxs: [],
                typestocks: [],
                entity: {},
                equipment: {},
                typedocuments:[],
                costcenters: [],
                operations:[],
                operationsleveltwos: [],
                operationslevelones: [],
                conditionpaymentreceipts: [],
                groupitems:[],
                typecosts: [],
                item:{},
                items: [],
                item_stock: {},
                items_stock:[],
                settlementforms:[],
                natureinboundoperations:[],
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                perPage: 5,
                currentPage: 1,
                fieldsEntity: [
                    { key: 'id', label: 'Código', sortable: true },
                    { key: 'name_entity', label: 'Nome', sortable: true },
                    { key: 'fantasy_name', label: 'Nome Fantasia', sortable: true },
                    { key: 'cnpj_cpf', label: 'CPF/CNPJ', sortable: false },
                    { key: 'blocked', label: 'Bloqueado', sortable: false,
                            formatter: value => value ? 'Sim' : 'Não' },               
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsRetention: [
                    { key: "name_retention", label: "Retenção", sortable:false },  
                    { key: "base_date", label: "Data Base", sortable:false,
                         formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                     },  
                    { key: "due_date", label: "Data Vencto", sortable:false,
                         formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                     },  
                    { key: "base_retention_value", label: "Valor Base", sortable:false },  
                    { key: "percent", label: "%", sortable:false }, 
                    { key: "retention_value", label: "Valor Retido", sortable:false }, 
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsPlot: [
                    { key: "due_date", label: "Vencto", sortable:false,
                         formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                     },       
                    { key: "portion_value", label: "Valor Parcela", sortable:false }, 
                    { key: "name_settlement_form", label: "Forma de Pagamento", sortable:false }, 
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsItemStock: [
                    { key: 'item_id', label: 'Item', sortable: false },   
                    { key: 'complements_name', label: 'Descrição', sortable: false },   
                    { key: 'location', label:"Complemento", sortable:false },
                    { key: 'initials', label: 'Und.', sortable: false },      
                    { key: 'stock_quantity', label: 'Qtde. Estoque', sortable: false },       
                    { key: 'price_unit_stock', label: 'Vr. Custo', sortable: false },   
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsItems:[
                    { key: 'id', label: 'Item', sortable: false },   
                    { key: 'complements_name', label: 'Descrição', sortable: false, variant: 'secondary' }, 
                    { key: 'initials', label: 'Und.', sortable: false },   
                    { key: 'name_group_item', label: 'Grupo de Item', sortable: false },  
                    { key: 'actions', label: 'Ações', variant: 'light' }       
                ],
                fieldsTax: [
                    { key: "nature_inbound_name", label: "Natureza Entrada", sortable:false }, 
                    { key: "name_tax", label: "Imposto", sortable:false }, 
                    { key: "base_tax_value", label: "Base", sortable:false },    
                    { key: "percent", label: "%", sortable:false }, 
                    { key: "tax_value", label: "Vr.Imposto", sortable:false }, 
                    { key: "tax_free_value", label: "Vr.Isento", sortable:false },
                    { key: "tax_others_value", label: "Vr.Outros", sortable:false },
                    { key: 'actions', label: 'Ações' }
                ],
                fieldsDocumentEntryItem:[
                    { key: 'item_id', label: 'Item', sortable: false }, 
                    { key: "complements_name", label: "Descrição do Item", sortable:false }, 
                    { key: 'initials', label: 'Und.', sortable: false },       
                    { key: 'entry_quantity', label: 'Qtde.', sortable: false },       
                    { key: 'entry_value_unit', label: 'Vr. Unitário', sortable: false },
                    { key: 'entry_value_discount', label: 'Vr. Desconto', sortable: false },
                    { key: 'entry_value_total', label: 'Vr. Total', sortable: false },
                    { key: 'actions', label: 'Ações' }
                ]
          }
         
      },
    computed: {
        issueDateState() {
            return this.documententry.issue_date ? true : false
        },
        documentNumberState() {
            return this.documententry.document_number > 0 ? true : false
        },
        typeDocumentState() {
            return this.documententry.type_document_id ? true : false
        },
        costCenterState() {
            return this.documententry.cost_center_id ? true : false
        },
        documentValueState() {
            return this.documententry.document_value > 0 ? true : false
        },
        typeCostState() {
            return this.documententry.type_cost_id ? true : false
        },
        operationState() {
            return this.documententry.operation_id ? true : false
        },
        operationLevelOneState() {
            return this.documententry.operation_level_one_id ? true : false
        },
        operationLevelTwoState() {
            return this.documententry.operation_level_two_id ? true : false
        },
        conditionPaymentReceiptState() {
            return this.documententry.condition_payment_receipt_id ? true : false
        },
        entityState() {
            return this.documententry.entity_id ? true : false
        },
        user(){
            return this.$store.state.user
        },
        compan(){
            return this.$store.state.compan
        },
        filteredList() {
            return this.entitys.filter(entity => {
                return ( 
                        entity.name_entity.toLowerCase().includes(this.searchEntity.toLowerCase()) || 
                        entity.cnpj_cpf.toLowerCase().includes(this.searchEntity.toLowerCase())
                )
            })
        },
        filteredListItems() {
            return this.items.filter(item => {
                return item.complements_name.toLowerCase().includes(this.searchItem.toLowerCase())
                })
        },
        rows() {
            return this.entitys.length
        },
        rowsItems() {
            return this.items.length
        },
        splotSum(){
            let value = 0
            return this.documententrysplots.map(splot=>{
              return value += parseFloat(splot.portion_value)
            })
        },
        itemSum(){
            let value = 0
            return this.documententrysitems.map(item=>{
              return value += parseFloat(item.entry_value_total)
            })
        },
        retentionSum(){
            let value = 0
            return this.documententrysretentions.map(retention=>{
              return value += parseFloat(retention.retention_value)
            })
        },
    },
    methods:{
            finalValue(){
                return this.documententrysplot.final_value = parseFloat((this.documententrysplot.portion_value - (this.documententrysplot.discount_value ? this.documententrysplot.discount_value : 0)) + + (this.documententrysplot.fine_value ? this.documententrysplot.fine_value : 0) + + (this.documententrysplot.interest_rate_value ? this.documententrysplot.interest_rate_value : 0)).toFixed(2)
            },
            ItemValue(){
                return this.documententrysitem.entry_value_total = parseFloat(parseFloat(this.documententrysitem.entry_quantity ? this.documententrysitem.entry_quantity : 0) * (parseFloat(this.documententrysitem.entry_value_unit ? this.documententrysitem.entry_value_unit : 0) - (this.documententrysitem.entry_value_discount ? this.documententrysitem.entry_value_discount : 0))).toFixed(2)
            },
            ItemUnitFinalValue(){
                return this.documententrysitem.entry_final_value_unit = parseFloat((parseFloat(this.documententrysitem.entry_value_unit ? this.documententrysitem.entry_value_unit : 0) - (this.documententrysitem.entry_value_discount ? this.documententrysitem.entry_value_discount : 0))).toFixed(2)
            },
            retentionValue(){
                return this.documententrysretention.retention_value = parseFloat(this.documententrysretention.base_retention_value * ((this.documententrysretention.percent ? this.documententrysretention.percent : 0) / 100)).toFixed(2)
            },
            taxValue(){
                return this.documententrystax.tax_value = parseFloat(this.documententrystax.base_tax_value * ((this.documententrystax.percent ? this.documententrystax.percent : 0) / 100)).toFixed(2)
            },
            goback(){
                 this.$router.go(-1, {query: 'q=s', hash: 'hashFrag'})
            }, 
            formatValue(value) {    
                return parseFloat(value ? value : 0).toFixed(2)
            },
            formatDate(date) {
                return moment.parseZone(date).format('YYYY-MM-DD')
            },
            formatDateTime(date) {
                return moment.parseZone(date).format('YYYY-MM-DD LT')
            },
            formatDateTimeReg(date) {
                return moment.parseZone(date).format('DD-MM-YYYY LT')
            },
            async validatedValueSplot(){

                await axios.get(`${baseApiUrl}/documentsplotsgettotal/${this.documententry.id}`)
                    .then(() => {
                        this.documententry.checkvalueplot = 1
                    })
                    .catch(showError) 
            },
            loaddocumententrysRetention(documententrysretention){
                if(documententrysretention.base_date) documententrysretention.base_date = this.formatDate(documententrysretention.base_date)
                if(documententrysretention.due_date) documententrysretention.due_date = this.formatDate(documententrysretention.due_date)
             
                this.documententrysretention = { ...documententrysretention }
            },
            loaddocumententrysTax(documententrystax){
                if(documententrystax.base_date) documententrystax.base_date = this.formatDate(documententrystax.base_date)
                this.documententrystax = { ...documententrystax }
            },
            loaddocumententrysItem(documententrysitem){
                this.documententrysitem = { ...documententrysitem }
            },
            loadDocumentEntrysPlot(documententrysplot){

                if(documententrysplot.due_date) documententrysplot.due_date = this.formatDate(documententrysplot.due_date)
                if(documententrysplot.scheduled_date) documententrysplot.scheduled_date = this.formatDate(documententrysplot.scheduled_date) 

                this.documententrysplot = { ...documententrysplot }
            },
            async loaddocumententrysRetentions(){
                const id = this.documententry.id
                const url = `${baseApiUrl}/documententrysretention/${id}/documententry`
                await axios.get(url).then(res => {
                    this.documententrysretentions = res.data
                })
           },
            async loaddocumententrysTaxs(){
                const id = this.documententry.id
                const url = `${baseApiUrl}/documententrystax/${id}/documententry`
                await axios.get(url).then(res => {
                    this.documententrystaxs = res.data
                })
           },
            async loadDocumentEntrysItems(){
                const id = this.documententry.id
                const url = `${baseApiUrl}/documententrysitems/${id}`
                await axios.get(url).then(res => {
                    this.documententrysitems = res.data
                })
           },  
            async loadDocumentEntrysPlots(){
                const id = this.documententry.id
                const url = `${baseApiUrl}/documententryssplots/${id}`
                await axios.get(url).then(res => {
                    this.documententrysplots = res.data
                })
           },      
            async saveDocumentEntry() {
                if(this.documententry.id){
                    this.documententry.user_update_id = this.user.id   
                    this.documententry.update_date = this.formatDate(Date())
                }else{

                    this.documententry.user_id = this.user.id   
                    if(!this.compan)
                    {
                         this.$toasted.global.defaultWarning({msg:'Logar na Empresa'}).catch(showError)
                    }else
                    {
                        this.documententry.company_id = this.compan.id
                    }
                    
                }    
                    const method = this.documententry.id ? 'put' : 'post'
                    const id = this.documententry.id ? `/${this.documententry.id}` : ''
                    await axios[method](`${baseApiUrl}/documententrys${id}`, this.documententry)
                        .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.getLastDocumentEntry()
                        })
                        .catch(showError)
            },
            async saveDocumentEntryItem() {
                const method = this.documententrysitem.id ? "put" : "post";
                const id = this.documententrysitem.id ? `/${this.documententrysitem.id}` : "";

                this.documententrysitem.user_id = this.user.id   
                this.documententrysitem.document_entry_id = this.documententry.id;

                await axios[method](`${baseApiUrl}/documententrysitems${id}`, this.documententrysitem)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess();
                        this.documententrysitem = {}
                        await this.loadDocumentEntrysItems();
                    })
                    .catch(showError)
            },
            async getLastDocumentEntry(){
                 const url = `${baseApiUrl}/documententryidlast/${this.documententry.company_id}/?user_id=${this.documententry.user_id}&entity_id=${this.documententry.entity_id}&document_value=${this.documententry.document_value}&type_document_id=${this.documententry.type_document_id}`
                   await axios(url).then(res=> 
                        this.documententry = {...this.documententry,id:res.data.id}
                    )
            },
            async confirmDocumentEntry() {
                if(this.documententry.id){

                        if(this.documententry.document_status_id === 2){
                            this.documententry.document_status_id = 1
                            this.docRead = false
                            this.documententry.checkvalueplot = 0
                        }
                        else{
                            this.documententry.document_status_id = 2
                            this.docRead = true
                        }
                        this.documententry.user_update_id = this.user.id   
                        this.documententry.update_date = this.formatDate(Date())
                        
                                   
                    const method = this.documententry.id ? 'put' : 'post'
                    const id = this.documententry.id ? `/${this.documententry.id}` : ''
                    await axios[method](`${baseApiUrl}/documententrys${id}`, this.documententry)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                        })
                        .catch(showError)
                }      
            },
            async saveRetention() {
                const method = this.documententrysretention.id ? "put" : "post";
                const id = this.documententrysretention.id ? `/${this.documententrysretention.id}` : "";
                this.documententrysretention.document_entry_id = this.documententry.id;
                await axios[method](`${baseApiUrl}/documententrysretentions${id}`, this.documententrysretention)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess();
                        this.documententrysretention = {}
                            await this.loaddocumententrysRetentions();
                    })
                    .catch(showError)
            },
            async saveTax() {
                const method = this.documententrystax.id ? "put" : "post";
                const id = this.documententrystax.id ? `/${this.documententrystax.id}` : "";
                this.documententrystax.document_entry_id = this.documententry.id;
                await axios[method](`${baseApiUrl}/documententrystaxs${id}`, this.documententrystax)
                    .then(async () => {
                    this.$toasted.global.defaultSuccess();
                    this.documententrystax = {}
                        await this.loaddocumententrysTaxs();
                    })
                    .catch(showError)
            },
            async saveItem() {
                const method = this.documententrysitem.id ? "put" : "post";
                const id = this.documententrysitem.id ? `/${this.documententrysitem.id}` : "";
                this.documententrysitem.documententry_id = this.documententry.id;
                await axios[method](`${baseApiUrl}/documententrysitems${id}`, this.documententrysitem)
                    .then(async () => {
                    this.$toasted.global.defaultSuccess();
                    this.documententrysitem = {}
                    this.item_stock = {}
                        await this.loaddocumententrysItems();
                    })
                    .catch(showError)
            },
            async savePlot() {

                if(this.documententrysplot.id){

                    this.documententrysplot.user_update_id = this.user.id   
                    this.documententrysplot.update_date = this.formatDate(Date())

                }else{

                    this.documententrysplot.user_id = this.user.id   
                }   
                    const method = this.documententrysplot.id ? "put" : "post";
                    const id = this.documententrysplot.id ? `/${this.documententrysplot.id}` : "";

                    this.documententrysplot.document_entry_id = this.documententry.id;

                    await axios[method](`${baseApiUrl}/documententryssplots${id}`, this.documententrysplot)
                            .then(() => {
                            this.$toasted.global.defaultSuccess();
                            this.documententrysplot = {}
                            this.loadDocumentEntrysPlots();
                            })
                            .catch(showError)
            },
            async removeRetention(documententrysretention) {
                    const id = documententrysretention.id
                    await axios.delete(`${baseApiUrl}/documententrysretentions/${id}`)
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loaddocumententrysRetentions()
                        })
                        .catch(showError)
            },
            async removePlot(documententrysplot) {
                    const id = documententrysplot.id
                    await axios.delete(`${baseApiUrl}/documententryssplots/${id}`)
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loadDocumentEntrysPlots()
                        })
                        .catch(showError)
            },
            async removeItem(documententrysitem) {
                    const id = documententrysitem.id
                    await axios.delete(`${baseApiUrl}/documententrysitems/${id}`)
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loadDocumentEntrysItems()
                        })
                        .catch(showError)
            },
            async loadRetention() {
                const url = `${baseApiUrl}/retentions`
                await axios.get(url).then(res => {
                    this.retentions = res.data.map(retention => {
                        return { value: retention.id, text: retention.name_retention }
                        })
                    })
            },
            async loadTax() {
                const url = `${baseApiUrl}/taxs`
                await axios.get(url).then(res => {
                    this.taxs = res.data.map(tax => {
                        return { value: tax.id, text: tax.name_tax }
                        })
                    })
             },
            async setEntity(entity) {
                if(!this.documententry.entity_id)
                {
                    this.documententry.entity_id = entity.id
                }
                const url = `${baseApiUrl}/entitys/${this.documententry.entity_id}`
                await axios(url).then(res=> this.entity = res.data)
            },
            async setSearchEntity() {
               this.documententry = {...this.documententry,entity_id: this.entity_id} 
               await this.getAdvancedValue()
            },
            async loadTypeCost() {
                const url = `${baseApiUrl}/typecosts`
                await axios.get(url).then(res => {
                    this.typecosts = res.data.map(typecost => {
                        return { value: typecost.id, text: typecost.name_type_cost }
                        })
                    })
            },    
            async loadCostCenter() {
                const url = `${baseApiUrl}/costcenteranalitic/${this.compan.id}`
                await axios.get(url).then(res => {
                    this.costcenters = res.data.map(costcenter => {
                        return { value: costcenter.id, text: costcenter.name_cost_center }
                        })
                    })
            },
            async loadConditionPaymentReceipt() {
                const url = `${baseApiUrl}/conditionpaymentreceipts`
                await axios.get(url).then(res => {
                    this.conditionpaymentreceipts = res.data.map(conditionpaymentreceipt => {
                        return { value: conditionpaymentreceipt.id, text: conditionpaymentreceipt.name_condition_payment_receipt }
                        })
                    })
            },
            async loadTypeDocument() {
                const url = `${baseApiUrl}/typedocuments`
                await axios.get(url).then(res => {
                    this.typedocuments = res.data.map(typedocument => {
                    return { value: typedocument.id, text: typedocument.name_reduced }
                    })
                })
            },
            async loadDocumentStaus() {

            const url = `${baseApiUrl}/documentstatus`
            await axios.get(url).then(res => {
                   this.documentstatus = res.data.map(documentstatu => {
                    return { value: documentstatu.id, text: documentstatu.name_document_status }
                    })
                })
            },
            async loadOperation() {
                const url = `${baseApiUrl}/operationpurchase`
                await axios.get(url).then(res => {
                    this.operations = res.data.map(operation => {
                        return { value: operation.id, text: operation.name_operation }
                        })
                    })
            },
            async loadOperationsLevelOnes() {
                const url = `${baseApiUrl}/operationslevelones/${this.documententry.operation_id}/operations`
                await axios.get(url).then(res => {
                    this.operationslevelones = res.data.map(operationslevelone => {
                            return { value: operationslevelone.id, text: operationslevelone.name_operation_level_one }
                            })
                    })
            },
            async loadOperationsLevelTwos() {
                const url = `${baseApiUrl}/operationsleveltwos/${this.documententry.operation_level_one_id}/operationslevelones`
                await axios.get(url).then(res => {
                    this.operationsleveltwos = res.data.map(operationsleveltwo => {
                        return { value: operationsleveltwo.id, text: operationsleveltwo.name_operation_level_two }
                        })
                })
            },
            async loadSettlementForms() {
                const url = `${baseApiUrl}/settlementforms`
                await axios.get(url).then(res => {
                   this.settlementforms = res.data.map(settlementform => {
                    return { value: settlementform.id, text: settlementform.name_settlement_form }
                    })
                })
            },
            async insertDocumentEntrySplotConfditionPayment(){

                 if(this.documententry.id){
                        const url = `${baseApiUrl}/insertdocumententrysplotconditionpaymentReceipt/${this.documententry.id}/?condition_payment_receipt_id=${this.documententry.condition_payment_receipt_id}&document_value=${this.retentionSum > 0 ? this.documententry.document_value - this.formatValue(this.retentionSum) : this.documententry.document_value }&issue_date=${this.documententry.issue_date}&settlement_form_id=${this.documententrysplot.settlement_form_id}&user_id=${this.user.id}`
                        await  axios.post(url).then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loadDocumentEntrysPlots()
                        })
                        .catch(showError)
                  }
            },
            async loadItemsStock(){
                if(this.documententrysitem.item_id > 0){
                    const url = `${baseApiUrl}/itemsstockshowdetail/${this.documententrysitem.item_id}/?company_id=${this.documententry.company_id}`
                     await axios.get(url).then(res => {
                    this.items_stock = res.data.map(item =>{
                        return { value: item.id, text: ('Localização: ' + item.type_stock_name + ' - '  + item.location  ) + ' | ' + 'Qtde. Estoque: ' + this.formatValue(item.stock_quantity) }
                    })
                })
                }
            },
            async loadItems(){
                const url = `${baseApiUrl}/groupitems/${this.group_item_id}/items`
                await axios.get(url).then(res => {
                    this.items = res.data
                })
            },
            async setItemSearch(itemsearch) {
                this.item= {...itemsearch}
                this.documententrysitem.item_id = this.item.id
                this.focusModalEntryItemQuantity()
                await this.loadItemsStock()
            },
            async setItem() {
                const url = `${baseApiUrl}/items/${this.documententrysitem.item_id}`
                await axios(url).then(res=> this.item = res.data)
            },
            loadDocumentEntrysItem(item){
                this.documententrysitem = {...item}
                this.item_stock.complements_name =  item.complements_name
                this.item_stock.initials = item.initials
            },
            async loadDocumetEntry(){
                const url = `${baseApiUrl}/documententrys/${this.documententry.id}`
                await axios.get(url).then(res => {
                            this.documententry = {...res.data}
                            this.loadDocumentEntrysItems()
                            this.loadDocumentEntrysPlots()
                            this.loaddocumententrysRetentions()
                            this.loaddocumententrysTaxs()
                            this.docRead = true
                    })
            },
             async loadNatureinboundOperation() {
                const url = `${baseApiUrl}/natureinboundoperations`
                await axios.get(url).then(res => {
                    this.natureinboundoperations = res.data.map(operation => {
                        return { value: operation.id, text: operation.nature_inbound_name + ' ('+ operation.code_small_nature + ')' }
                        })
                    })
            },
            async removeTax(documententrystax) {
                    const id = documententrystax.id
                    await axios.delete(`${baseApiUrl}/documententrystaxs/${id}`)
                        .then(async () => {
                            this.$toasted.global.defaultSuccess()
                            await this.loaddocumententrysTaxs()
                        })
                        .catch(showError)
            },
            loadGroupItems() {
                const url = `${baseApiUrl}/groupitems`
                axios.get(url).then(res => {
                    this.groupitems = res.data.map(groupitem => {
                        return { value: groupitem.id, text: !groupitem.synthetic ? ' => ' + groupitem.name : groupitem.name, disabled: groupitem.synthetic ? true: false }
                    })
                })
            },
            async setEquipment(equipment) {

                if(!this.documententrysitem.equipment_id)
                {
                    this.documententrysitem.equipment_id = equipment.id
                }

                const url = `${baseApiUrl}/equipments/${this.orderservice.equipment_id}`
                await axios(url).then(res=> this.equipment = res.data)

            },
            async getAdvancedValue(){
                if(this.documententry.document_status_id === 1){
                    const url = `${baseApiUrl}/accountingentryadvanced/${this.compan.id}/?entity_id=${this.documententry.entity_id}&operation_id=${this.documententry.operation_id}`
                    await axios(url).then(res=> 
                        this.documententry = {...this.documententry,advanced_value:res.data.value_advance}
                    )
                }
            },
            setSearchEquipment() {
                this.documententrysitem = {...this.documententrysitem,equipment_id : this.equipment_id}
            },
            setNewRetention(){
                this.documententrysretention = {}
                this.documententrysretention.base_retention_value = this.documententry.document_value
                this.documententrysretention.base_date = moment(this.documententry.issue_date).format('YYYY-MM-DD')
            },
            setNewTax(){
                this.documententrystax = {}
                this.documententrystax.base_tax_value = this.documententry.document_value
                this.documententrystax.base_date = moment(this.documententry.issue_date).format('YYYY-MM-DD')
            },
            hideModal() {
                this.$bvModal.hide('modalEntity')
                this.$bvModal.hide('modalItem')
            },
            openModalEntity(){
            this.$bvModal.show('modalEntity')
            },
            openModalItem(){
                this.$bvModal.show('modalItem')
            },
            focusModalEntity(){
                this.$refs.focusEntity.focus()
            },
            focusModalItem(){
                this.$refs.focusItem.focus()
            },
             focusModalEntryItem(){
                this.$refs.focusEntryItem.focus()
            },
            focusModalEntryItemQuantity(){
                this.$refs.focusEntryItemQuantity.focus()
            },
            focusModalEntryItemValueUnit(){
                this.$refs.focusEntryItemValueUnit.focus()
            },
            focusModalEntryItemValueDesc(){
                this.$refs.focusEntryItemValueDesc.focus()
            },
            setNewItem(){
                this.documententrysitem = {}
            },
            saveDocumentEntryItemTax(){

            }
            
      },
    watch:{
            $route(to){
                //this.documententry = to.params
                this.documententry = to.query.documententrybase
            
                //this.loadDocumentEntrybase()
            } 
        },
       async mounted(){

            if(!this.$route.query.documententrybase){
                this.documententry.id = this.$route.params.id
               await this.loadDocumetEntry()
               await this.setEntity()
               this.documententry = {...this.documententry,issue_date : this.formatDate(this.documententry.issue_date)}

            }else{
                this.documententry = this.$route.query.documententrybase
                this.docRead = this.documententry.document_status_id === 1 ? false : true
                this.entity.name_entity = this.documententry.name_entity
                this.entity.cnpj_cpf = this.documententry.cnpj_cpf
            }

            
            if(!this.documententry.issue_date){

               const date = new Date() 
                this.documententry.issue_date = moment.utc(date).local().format('YYYY-MM-DD')
            }
            //this.loadDocumentEntry()
            this.loadRetention()
            this.loadTax()
            this.loadTypeCost()
            this.loadCostCenter()
            this.loadConditionPaymentReceipt()
            this.loadTypeDocument()
            this.loadOperation()
            this.loadDocumentEntrysItems()
            this.loadDocumentEntrysPlots()
            this.loadDocumentStaus()
            this.loadSettlementForms()
            this.loadNatureinboundOperation()
            this.loaddocumententrysRetentions()
            this.loadGroupItems()

        }
}
</script>

<style>
     .record-documententry select,label{
        font-size: 0.7rem;
    }
    .record-documententry input{
        font-size: 0.7rem;
    }
     .record-documententry button{
        font-size: 0.7rem;
    }
     .record-documententry h6{
        font-size: 0.7rem;

    }

    #modalDocumentEntryItem select,label{
        font-size: 0.7rem;
    }

    #modalDocumentEntryItem input{
        font-size: 0.7rem;
    }

    #modalDocumentEntryItem button{
        font-size: 0.7rem;
    }

    #modalDocumentEntryItemTaxs button {
        font-size: 0.7rem;
    }

        #modalDocumentEntryItemTaxs input {
        font-size: 0.7rem;
    }

    #modalSplotConditionPayment select,label{
        font-size: 0.7rem;
    }

    #modalSplotConditionPayment input{
        font-size: 0.7rem;
    }

    #modalSplotConditionPayment button{
        font-size: 0.7rem;
    }

    #modalItem input {
        font-size: 0.7rem;
    }

    #modalItem button {
        font-size: 0.7rem;
    }
    
    #modalPlots select,label{
        font-size: 0.7rem;
    }

    #modalPlots input{
        font-size: 0.7rem;
    }

    #modalPlots button{
        font-size: 0.7rem;
    }

     #modalTax{
         font-size: 0.7rem;
    }

    #modalTax select,label{
         font-size: 0.7rem;
    }

    #modalTax input{
         font-size: 0.7rem;
    }

    #modalTax button{
         font-size: 0.7rem;
    }

    #modalRetention{
         font-size: 0.7rem;
    }

    #modalRetention select,label{
         font-size: 0.7rem;
    }

    #modalRetention input{
         font-size: 0.7rem;
    }

    #modalRetention button{
         font-size: 0.7rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }
</style>
